import React from 'react';
import axios from 'axios';

import AppVars from '../../AppVars.js'
import Logger from '../../Logger.js';
import { constants } from '../../constants/constants';
import ResendPasswordFormView from '../Views/TO/Reset/ResendPasswordFormView';

const appVars = AppVars.getInstance();
const logger = Logger.getInstance();

class ResendPasswordForm extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
            email: "",
            successEmail: "",
            loginURI: "",

            floatEmail: true,
            emailFocus: null,

            isEmailValid: true,
            
            // State for resending activation email and the outcome of that functionality
            loadingReset: false,

            // Controls the above values based on the outcome of the activate API call, default is false

            serviceFailure: false
        }

        this.emailRegex = new RegExp(constants.EMAIL_VALIDATION_REGEX)
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.processEmail = this.processEmail.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.onBlurEmail = this.onBlurEmail.bind(this);
        this.onFocusEmail = this.onFocusEmail.bind(this);
        this.removeFocusEmail = this.removeFocusEmail.bind(this);
    }

   
    render() {
        return(

            <ResendPasswordFormView 
            showForm = {this.props.showForm}
            loadingReset = {this.state.loadingReset}
            isEmailValid = {this.state.isEmailValid}
            floatEmail = {this.state.floatEmail}
            processEmail = {this.processEmail}
            handleEmailChange = {this.handleEmailChange}
            onFocusEmail = {this.onFocusEmail}
            onBlurEmail = {this.onBlurEmail}
            emailFocus = {this.state.emailFocus}
            style = {this.props.style}
            />
        
        )
    }

    processEmail(event) {
        event.preventDefault()
        if (!this.state.email || !this.emailRegex.test(this.state.email)) {
            this.setState({
                isEmailValid: false
            });
        } else {
            this.setState({
                isEmailValid: true
            });
            this.sendEmail();
        }
    }

    async sendEmail() {
        const dest = this.props.loginURI === "" ? "/" : this.props.loginURI;
        const email = this.state.email.trim();
        this.setState({
            loadingReset: true
        });
        await axios({
            headers: {
                'X-BRAND': 'T',
                "x-client" : "FR-Portal-Toyota",
                //"x-client" : "SI-REG"
            },
            method: 'post',
            url: appVars.getAPIGatewayURL() + "/password/" + email,
            // url: '/v2/admin/customer/password/' + email,
            /*headers: {
                'X-API-KEY': await appVars.getAPIKey(),
                'X-BRAND': 'T',
                'X-CLIENT': 'SI-REG',
                'X-VERSION': '1.6',
                'Content-Type': 'application/json',
            },*/
            data: {
                'redirectURI': dest
            }
        })
        .then((resp) => this.handleDCS3Response(resp))
        .catch((err) => this.handleDCS3Error(err))
    }

    handleDCS3Response(resp) {
        // Following along with the DCS3 repo
        this.setState({
            loadingReset: false
        })
        this.props.setEmail(this.state.email.trim())
        this.props.displayForm("SENT")
    }

    handleDCS3Error(err) {
        const error = err.response.data
        logger.log('stage', error)
        if (error.status.code == '400') {
            if (typeof error['status']['messages'] !== 'undefined') {
                if (error['status']['messages'][0]['code'] == constants.INACTIVATED_EMAIL_ID) {
                    this.setState({
                        loadingReset: false
                    })
                    this.props.displayForm("INACTIVE")
                    // this.passwordStateService.changeState('INACTIVE');
                }
            } else {
                if (this.props.showForm === "ERROR") {
                    this.setState({
                        loadingReset: false
                    });
                    this.props.displayForm("FAILURE")
                } else {
                    this.setState({
                        loadingReset: false
                    });
                    this.props.displayForm("ERROR")
                }
            }
        } else {
            if (this.props.showForm === "ERROR") {
                this.setState({
                    loadingReset: false
                });
                this.props.displayForm("FAILURE")
            } else {
                this.setState({
                    loadingReset: false
                });
                this.props.displayForm("ERROR")
            }
        }
    }

    resendActivation() {
        alert("This isn't supported. Check prod if you'd like.");
        window.location.href = "/resend";
    }

    handleEmailChange(event) {
        this.setState({email: event.target.value});
        this.setState({isEmailValid: this.validateInput(event.target.value)})
    }

    onFocusEmail() {
        this.setState({
            floatEmail: false,
            emailFocus: true
        });
    }

    removeFocusEmail(){
        this.setState({emailFocus: false})
    }

    onBlurEmail() {
        if (this.state.email === "") {
            this.setState({
                floatEmail: true
            });
        } else {
            this.setState({
                floatEmail: false
            });
        }
        this.removeFocusEmail()
        this.setState({isEmailValid: this.validateInput(this.state.email)})
    }

    validateInput(email) {
        const trimEmail = email.trim()
        const invalidInput = !trimEmail || !this.emailRegex.test(trimEmail);
        return !invalidInput;
    }
}

export default ResendPasswordForm